import { interopDefault } from '~/router/utils'

export default [
  {
    name: '__piraeus_loan_terms',
    path: '/loans/piraeus-loan-terms/',
    component: () =>
      interopDefault(
        import(
          '~/pages/shared/piraeus-loan-terms.vue' /* webpackChunkName: "shared-piraeus-loan-terms.vue" */
        )
      )
  }
]
